import { FieldValidator } from 'final-form'
import { decryptAES } from './cipher'
import * as utils from './utilityFunction'

export const composeValidators =
    (...validators: FieldValidator<any>[]): FieldValidator<any> =>
    (value, allValues, meta): string | undefined => {
        return validators.reduce(
            (error: string | undefined, validator) => error || validator(value, allValues, meta),
            undefined,
        )
    }

type FieldValidatorCustomErrorMessage<T> = (errorMessage?: string) => FieldValidator<T>
export const textRequired: FieldValidatorCustomErrorMessage<string | number> =
    (errorMessage = 'กรุณากรอกข้อความ') =>
    (value, allValues: any, meta) => {
        const submitType: any = allValues?.submitType
        if (typeof value === 'undefined' || value === null || value === '') {
            if (submitType === 'draft' && meta?.name !== 'projectNameTH') {
                return null
            } else {
                return errorMessage
            }
        }
    }

export const validateFormatLonLat = (longitude: number, latitude: number) => {
    const latitudePattern = /^(\+|-)?(?:90(?:(?:\.0{1,8})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,8})?))$/g
    const longitudePattern = /^(\+|-)?(?:180(?:(?:\.0{1,8})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,8})?))$/g
    return longitudePattern.test(longitude.toString()) && latitudePattern.test(latitude.toString())
}

export const validateFormatDMS = (x: string, y: string) => {
    const xPattern = /([0-9]{1,2})[:|°]([0-9]{1,2})[:|'|′]?([0-9]{1,2}(?:\.[0-9]+){0,1})?["|″|]?([N|S])?/g
    const yPattern = /([0-9]{1,3})[:|°]([0-9]{1,2})[:|'|′]?([0-9]{1,2}(?:\.[0-9]+){0,1})?["|″]?([E|W])?/g
    return xPattern.test(x) && yPattern.test(y)
}

export const validateFormatUTM = (x: number, y: number) => {
    const xPattern = /\d*\.?\d*$/g
    const yPattern = /\d*\.?\d*$/g
    return xPattern.test(x.toString()) && yPattern.test(y.toString())
}

export const validateFormatLatLong = (value: string) => {
    const latLongPattern = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/g
    return latLongPattern.test(value.toString())
}

export const validateLatLonOrDMS = (value: string) => {
    const latAndlonPattern = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/g
    const latOnlyPattern = /^(\-?([0-8]?[0-9](\.\d+)?|90(.[0]+)?)[,])/g
    const latAndCommaPattern = /^(\-?([0-8]?[0-9](\.\d+)?|90(.[0]+)?))/g

    let result = false
    if (
        latAndlonPattern.test(value.toString()) ||
        latOnlyPattern.test(value.toString()) ||
        latAndCommaPattern.test(value.toString())
    ) {
        result = true
    } else {
        const dms = utils.separateWordCommaDMS(value ?? '')
        if (validateFormatDMS(dms.x, dms.y)) {
            result = true
        }
    }

    return result
}

export const validateFormatUTMTest = (xy: string) => {
    const xPattern = /(\-?(\d*\.?\d*)?\s?[,]\s?)+(\-?(\d*\.?\d*)?\s?[,]\s?)/g
    return xPattern.test(xy.toString())
}

export const validateISYL = (encryptedPwd: string) => {
    // ต้องมีความยาว 8 - 20 ตัวอักษร ประกอบไปด้วยตัวอักษรภาษาอังกฤษ พิมพ์ใหญ่ พิมพ์เล็ก และตัวเลข
    const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,20}$/g
    const password = decryptAES(encryptedPwd)

    return passwordPattern.test(password)
}

export const validateFormatNumberOnly = (number: string | number) => {
    const pattern = /^[1-9][\.\d]*(,\d+)?$/g
    return pattern.test(number.toString())
}

export const validateFormatTelephone = (telephone: string) => {
    let format1 = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/g // เบอร์มือถือ เช่น 081-234-5678 หรือ 0812345678
    let format2 = /^\(?([0-9]{2})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/g // เบอร์บ้าน (กทม.) เช่น 02-123-4567 หรือ 021234567
    let format3 = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{3})$/g // เบอร์บ้าน (ตจว.) เช่น 034-123-456 หรือ 034123456

    let result = false
    if (format1.test(telephone)) result = true
    if (format2.test(telephone)) result = true
    if (format3.test(telephone)) result = true
    return result
}
